module.exports = __webpack_public_path__ + "resources/img/bg_banner_tcc_orgin.8189fc48e079947e4cf7cc42b2a96bff.png";